import { EnumDictionary } from './EnumDictionary';

export enum TilgangstypeEnum{
    IngenTilgang = 0, //No access
    LeseOgRedigere = 10,//Read and Edit
    LeseOgRedigereEnkeltElementer = 20, //Read And Edit Simple Elements
    Lese = 30,//read
}



export const TilgangstypeDictionary: EnumDictionary<TilgangstypeEnum, string> = {
    [TilgangstypeEnum.IngenTilgang]: 'Ingen tilgang',
    [TilgangstypeEnum.LeseOgRedigere]: 'Lese og redigere',
    [TilgangstypeEnum.LeseOgRedigereEnkeltElementer]: 'Lese og redigere enkeltelementer',
    [TilgangstypeEnum.Lese]: 'Lese',
};